import React from 'react';

export function ProcessFlowDiagram({ className = '' }) {
  return (
    <svg viewBox="0 0 900 500" className={className} xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
      <defs>
        <filter id="shadow" x="-4%" y="-4%" width="108%" height="108%">
          <feDropShadow dx="0" dy="2" stdDeviation="4" floodOpacity="0.08" />
        </filter>
        <font-face fontFamily="system-ui, -apple-system, sans-serif" />
      </defs>

      {/* Refinement Section */}
      <rect x="40" y="30" width="400" height="390" rx="20" fill="#fdf6ef" stroke="#e8d5c0" strokeWidth="1.5" filter="url(#shadow)" />
      <text x="240" y="68" textAnchor="middle" fontFamily="inherit" fontSize="14" fontWeight="700" letterSpacing="0.08em" fill="#9a7b5a">REFINEMENT</text>

      {/* Execution Section */}
      <rect x="460" y="30" width="400" height="390" rx="20" fill="#f0f4f8" stroke="#c5d4e0" strokeWidth="1.5" filter="url(#shadow)" />
      <text x="660" y="68" textAnchor="middle" fontFamily="inherit" fontSize="14" fontWeight="700" letterSpacing="0.08em" fill="#5a7a9a">EXECUTION</text>

      {/* Refinement Nodes */}
      <rect x="130" y="100" width="220" height="56" rx="10" fill="#ffffff" stroke="#e0cdb8" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="240" y="125" textAnchor="middle" fontFamily="inherit" fontSize="11.5" fontWeight="600" fill="#3d3225">Definition of requirements</text>
      <text x="240" y="142" textAnchor="middle" fontFamily="inherit" fontSize="11.5" fontWeight="600" fill="#3d3225">and success criteria</text>

      <rect x="130" y="190" width="220" height="48" rx="10" fill="#ffffff" stroke="#e0cdb8" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="240" y="219" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="600" fill="#3d3225">CAD received</text>

      <rect x="130" y="280" width="220" height="48" rx="10" fill="#ffffff" stroke="#e0cdb8" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="240" y="309" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="600" fill="#3d3225">Process Simulated</text>

      {/* Refinement Arrows */}
      <path d="M240 156 L240 190" stroke="#c4a882" strokeWidth="1.5" fill="none" />
      <polygon points="235,185 240,193 245,185" fill="#c4a882" />

      <path d="M240 238 L240 280" stroke="#c4a882" strokeWidth="1.5" fill="none" />
      <polygon points="235,275 240,283 245,275" fill="#c4a882" />

      {/* Arrow from Process Simulated to Toolbits - clean L-shape */}
      <path d="M240 328 L240 370 L450 370 L450 124 L550 124" stroke="#8a9baa" strokeWidth="1.8" fill="none" strokeDasharray="6 3" />
      <polygon points="545,119 555,124 545,129" fill="#8a9baa" />

      {/* Execution Nodes */}
      <rect x="550" y="100" width="220" height="48" rx="10" fill="#ffffff" stroke="#b8cfe0" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="660" y="128" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="600" fill="#2a3d4f">Toolbits and Fixtures secured</text>

      <rect x="550" y="185" width="220" height="48" rx="10" fill="#ffffff" stroke="#b8cfe0" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="660" y="213" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="600" fill="#2a3d4f">Test Recipe</text>

      <rect x="550" y="270" width="220" height="48" rx="10" fill="#ffffff" stroke="#b8cfe0" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="660" y="298" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="600" fill="#2a3d4f">Iterate and Optimise</text>

      <rect x="550" y="350" width="220" height="48" rx="10" fill="#e8f5e9" stroke="#81c784" strokeWidth="1.2" filter="url(#shadow)" />
      <text x="660" y="378" textAnchor="middle" fontFamily="inherit" fontSize="12" fontWeight="700" fill="#2e7d32">Finalise Recipe</text>

      {/* Execution Arrows */}
      <path d="M660 148 L660 185" stroke="#7a9ab8" strokeWidth="1.5" fill="none" />
      <polygon points="655,180 660,188 665,180" fill="#7a9ab8" />

      <path d="M660 233 L660 270" stroke="#7a9ab8" strokeWidth="1.5" fill="none" />
      <polygon points="655,265 660,273 665,265" fill="#7a9ab8" />

      <path d="M660 318 L660 350" stroke="#7a9ab8" strokeWidth="1.5" fill="none" />
      <polygon points="655,345 660,353 665,345" fill="#7a9ab8" />

      {/* Loop arrow: Iterate back to Test Recipe */}
      <path d="M770 294 L800 294 L800 209 L770 209" stroke="#7a9ab8" strokeWidth="1.5" fill="none" strokeDasharray="4 2" />
      <polygon points="775,204 765,209 775,214" fill="#7a9ab8" />
      <text x="812" y="255" fontFamily="inherit" fontSize="9.5" fill="#7a9ab8" fontStyle="italic">loop</text>

      {/* Timeline Labels */}
      <text x="240" y="455" textAnchor="middle" fontFamily="inherit" fontSize="16" fontWeight="700" fill="#9a7b5a">3 days</text>

      <text x="660" y="455" textAnchor="middle" fontFamily="inherit" fontSize="16" fontWeight="700" fill="#5a7a9a">17 days</text>

    </svg>
  );
}
